import { Modal, ModalBody, ModalHeaderDefault } from 'ui-components/dist/Modal';
import {
  AddPlatformForm,
  ConfirmPlatform,
  useAddNewPlatformsStore,
} from '~/screens/ManagePlatforms/AddNewPlatformsModal';

export const AddNewPlatformsModal: React.FC = () => {
  const { isModalOpen, platform, setIsModalOpen } = useAddNewPlatformsStore();

  return (
    <Modal isOpen={isModalOpen} onClose={() => setIsModalOpen(false)} size="md">
      <ModalHeaderDefault
        title={
          platform ? 'Is this the account you want to add?' : 'Add new platform'
        }
      />
      <ModalBody>
        {platform ? <ConfirmPlatform /> : <AddPlatformForm />}
      </ModalBody>
    </Modal>
  );
};
